export const transformGetArticlesResponse = ({ data }) => ({
  articles: data.articles.map((article) => ({
    articleImage: article?.image ?? null,
    content: article.html,
    courseModuleId: article.course_module_id,
    id: article.id,
    isRead: article.is_passed,
    titleText: article.title,
    wasSeenCount: article.views,
  })),
});

export const transformGetArticlesWithBookletsResponse = ({ data }) => ({
  articles: data.articles.map((article) => ({
    articleImage: article?.image ?? null,
    id: article.id,
    isWithBooklet: true,
    titleText: article.title,
    wasSeenCount: article.views,
  })),
});

export const transformGetArticleWithBookletsByIdResponse = ({ data }) => ({
  articleImage: data?.image ?? null,
  bookletLink: data?.booklet,
  id: data?.id,
  titleText: data?.title ?? '',
  wasSeenCount: data?.views,
});

export const transformGetArticleByIdResponse = ({ data }) => ({
  articleImage: data?.image ?? null,
  content: data.html,
  courseModuleId: data.course_module_id,
  id: data?.id,
  isRead: data.is_passed,
  titleText: data?.title ?? '',
  wasSeenCount: data?.views,
});

export const transformGetVideosResponse = ({ data }) => ({
  videos: data.theory.map((video) => ({
    courseModuleId: video.course_module_id,
    id: video.id,
    subtitleText:
      typeof video?.course_module?.order_number === 'number'
        ? video.course_module.order_number + 1
        : '',
    titleText: video.title,
    videoImage: video?.thumbnail ?? null,
    videoUrl: video.video_url,
    wasSeenCount: video.views,
  })),
});

export const transformGetCardDefinitionByModuleIdResponse = ({ data }) => ({
  cards: data.card_definitions.sort(
    (definitionFirst, definitionSecond) =>
      definitionFirst.lesson.order_number - definitionSecond.lesson.order_number
  ),
  courseModuleId: data.course_module.id,
  courseModuleTitle: data.course_module.title,
});

export const transformGetScenarioByIdResponse = ({ data }) => ({
  ...data,
});
